module.exports = __webpack_public_path__ + "img/app_icon_current_node.a2d3973a.png";